import { render, staticRenderFns } from "./Plugins.vue?vue&type=template&id=5070a878"
import script from "./Plugins.vue?vue&type=script&lang=ts"
export * from "./Plugins.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports